import FloatingPopup from './FloatingPopup'
export default FloatingPopup
